module.exports = __webpack_public_path__ + "static/media/VisMerch.419b1d0f.jpg";